import type { FC } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useActiveDialogCleaner } from '../../../../store/actions/useActiveDialogCleaner';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { useHeaderSlice } from '../../../../store/slices/header/selectors';
import { headerActions } from '../../../../store/slices/header/slice';
import { HeaderModal } from '../../../../store/slices/header/types';

import { SettingsControlPlain } from './SettingsControlPlain';

export const SettingsControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const hideUI = useGameStateSlice.hideUI();
  const cleanDialogs = useActiveDialogCleaner();

  return (
    <SettingsControlPlain
      condition={openedModal === HeaderModal.Settings && !hideUI}
      onClick={(): void => {
        // UIC-64 | Hide Dialogs Functionality
        if (hideUI) {
          cleanDialogs();
        }
        if (!hideUI && openedModal === HeaderModal.Settings) {
          dispatch(headerActions.setOpenedModal(null));
        } else {
          Logger.logEvent('openSettings');
          dispatch(headerActions.setSettingsTabIndex(0));
          dispatch(headerActions.setOpenedModal(HeaderModal.Settings));
        }
      }}
    />
  );
};
